<template>
  <v-card class="base-card shadow">
    <v-card-title class="headline accent--text pb-4">
      {{ title }}
    </v-card-title>

    <v-card-text>
      <CardFieldRow
        v-model="nirAccomplishment.scientificHeadName"
        label="Научный руководитель(и)/консультант(ы)"
        placeholder="Добавьте научный руководитель(и)/консультант(ы)"
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.scientificHeadName"
        @input="
          $v.nirAccomplishment.scientificHeadName.$touch()
          updateNirAccomplishment()
        "
      />

      <CardAutocompleteRow
        v-model="nirAccomplishment.speciality"
        :items="specialityList"
        item-value="id"
        item-text="name"
        label="Специальность"
        placeholder="Выберите специальность"
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.speciality"
        :no-filter="false"
        @input="
          $v.nirAccomplishment.speciality.$touch()
          updateNirAccomplishment()
        "
      />

      <CardFieldRow
        v-model="nirAccomplishment.commonWork.workName"
        label="Название темы научного исследования"
        placeholder="Добавьте название темы научного исследования"
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.workName"
        @input="
          $v.nirAccomplishment.commonWork.workName.$touch()
          updateNirAccomplishment()
        "
      />

      <CardFieldRow
        v-model="nirAccomplishment.executionTerm"
        label="Срок исполнения"
        placeholder="Добавьте срок исполнения"
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.executionTerm"
        @input="
          $v.nirAccomplishment.executionTerm.$touch()
          updateNirAccomplishment()
        "
      />

      <CardAutocompleteRow
        v-model="nirAccomplishment.nirType"
        :items="nirTypeList"
        item-value="id"
        item-text="name"
        label="Вид НИР"
        placeholder="Выберите вид НИР"
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.nirType"
        @input="
          $v.nirAccomplishment.nirType.$touch()
          updateNirAccomplishment()
        "
      />

      <CardFieldRow
        v-model="nirAccomplishment.printedWork"
        label="Печатные работы по теме НИР"
        placeholder="Добавьте печатные работы по теме НИР"
        hide-border-bottom
        :disabled="isShowMode"
        :required="!isShowMode"
        :error-messages="errorMessages.printedWork"
        @input="
          $v.nirAccomplishment.printedWork.$touch()
          updateNirAccomplishment()
        "
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { NirAccomplishment } from '@/models'
import CardFieldRow from '../../ui/row/CardFieldRow'
import CardAutocompleteRow from '../../ui/row/CardAutocompleteRow'
import { setValidateMessages } from '../../../scripts/validation'
import { required, maxLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  components: { CardAutocompleteRow, CardFieldRow },
  props: {
    isShowMode: Boolean,
    selectedItem: Object,
    title: String
  },

  data: () => ({
    nirAccomplishment: new NirAccomplishment()
  }),

  validations() {
    return {
      nirAccomplishment: {
        commonWork: {
          workName: { required }
        },

        scientificHeadName: { required },
        speciality: { required },
        executionTerm: { required, maxLength: maxLength(50) },
        nirType: { required },
        printedWork: { required }
      }
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['nirTypeList', 'specialityList']),

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.nirAccomplishment.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.nirAccomplishment[key])
      })

      Object.keys(this.$v.nirAccomplishment.commonWork.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.nirAccomplishment.commonWork[key])
      })

      return allErrors
    }
  },

  methods: {
    updateNirAccomplishment() {
      this.$emit('update:selected-item', new NirAccomplishment(this.nirAccomplishment.getForAPI()))
      this.updateInvalid()
    },

    updateInvalid() {
      this.$emit('updateInvalid', this.$v.$invalid)
    }
  },

  watch: {
    selectedItem: {
      immediate: true,
      deep: true,
      handler(val) {
        this.nirAccomplishment = new NirAccomplishment(val.getForAPI())
        this.updateInvalid()
      }
    }
  }
}
</script>

<style scoped></style>
